import { ru } from '@/locale/business/ru-RU'
import { en } from '@/locale/business/en-US'

export const businessLang = { ru, en }
